export function* generator_mission_null(): Generator<number, number, number> {
  return 0
}
